const menuItemGroupProps = {
  title: String
};

export { menuItemGroupProps };
//# sourceMappingURL=menu-item-group3.mjs.map
